import axios from 'axios';

import { flattenData } from '~/helpers/journal';

import urls from './urls';
import { Secret } from './models';

export const encode = async (
  message: string,
  original: File
): Promise<File> => {
  const encodeInfo = new FormData();

  encodeInfo.append('message', message);
  encodeInfo.append('original', original);

  // Get response from Journal
  const response = await axios.post(urls.encode, encodeInfo, {
    responseType: 'arraybuffer',
  });

  return new File([response.data], response.headers.filename, {
    type: response.headers['content-type'],
  });
};

export const decode = async (
  encoded: File,
  original?: File
): Promise<Secret> => {
  const decodeInfo = new FormData();

  decodeInfo.append('encoded', encoded);
  if (original) decodeInfo.append('original', original);

  // Get response from Journal
  const response = await axios.post(urls.decode, decodeInfo);

  return flattenData(response.data.data.attributes);
};
